<template>

  <v-container fluid class="grey lighten-5">
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- left  ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <v-row v-show="!dashboardOpen">
      <v-col sm="6" md="2">
        <v-card outlined flat>
          <v-card-title>
                <v-avatar color="secondary darken-1" size="24">
                    <span class="white--text body-1 font-weight-bold">1</span>
                </v-avatar>
                <h3 class="title font-weight-light pl-1">Add Assets</h3>
          </v-card-title>

          <v-card-text text-center>
            <v-row 
                v-for="(item, index) in components"
                :key="'cc_' + index">

                <v-col cols="12" class="text-center">
                    <v-badge right top overlap color="orange darken-3">
                        <template v-slot:badge>
                            <span class="white--text">+</span>
                        </template>
                        <v-btn 
                            @click="onAdd(item.key)"
                            color="success" tile large icon>
                            <v-avatar size="36">
                                <v-img :src="genImg(item.key)"></v-img>
                            </v-avatar>
                        </v-btn>
                    </v-badge>
                    <br /><span class="caption">{{ item.title }}</span>
                    <v-divider
                        v-if="index + 1 < components.length"
                        :key="'cd_' + index"
                    ></v-divider>
                </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
      <!-- center  ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
      <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
      <v-col md="5">
        
        <!-- internal  ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <v-card outlined flat class="mb-1">
            <v-card-title>
                <v-avatar color="secondary darken-1" size="24">
                    <span class="white--text body-1 font-weight-bold">2</span>
                </v-avatar>
                <h3 class="title font-weight-light pl-1">To Your Microgrid</h3>
            </v-card-title>

            <v-card-text>
                <!-- summary -->
                <v-card flat>
                    <v-card-text>
                        <v-layout row>
                            <v-flex text-left>
                                <h3 class="body-2 text-uppercase font-weight-medium pl-2 mt-3">
                                    Internal Supply
                                </h3>
                            </v-flex>
                            <div class="flex-grow-1"></div>
                            <v-flex text-right>
                                <div class="display-1 text-right grey--text text--darken-3 compress">
                                    {{ totalsInternal | num }}
                                    <span class="caption">kW</span>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-divider px-2></v-divider>

                        <!-- assets -->
                        <v-layout row>
                            <table width="100%" border="0">
                                <tbody style="border:0;">
                                    <tr v-for="(item,i) in internalSupply" 
                                        :key="i"
                                        class="text-left subheading"
                                        style="border:0;"
                                        >
                                        <td>
                                            <v-img :src="genImg(item.key)" class="pr-1" width="30px"></v-img>
                                        </td>
                                        <td>{{ item.name }} <span class="caption">({{ item.title }})</span></td>
                                        <td class="text-right"><strong>{{ item.value }}</strong> {{ item.unit }}</td>
                                        <td class="text-right">
                                            <v-icon
                                                @click="onRemove(item.component_id)"
                                                color="red darken-2"
                                                >
                                                delete_forever
                                            </v-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </v-layout>
                    </v-card-text>
                </v-card>

                <!-- totals -->
                <v-layout row class="indigo lighten-5 justify-center">
                    <v-flex text-center>
                        <span class="font-weight-bold">
                            SOLAR
                            <div class="subheading">
                                {{ totalsSolar | num }}
                                <span class="caption">kW</span>
                            </div>
                        </span>
                    </v-flex>
                    <v-flex text-center>
                        <span class="font-weight-bold">
                            WIND
                            <div class="subheading">
                                {{ totalsWind | num }}
                                <span class="caption">kW</span>
                            </div>
                        </span>
                    </v-flex>
                    <v-flex text-center>
                        <span class="font-weight-bold">
                            GENERATION
                            <div class="subheading">
                                {{ totalsGeneration | num }}
                                <span class="caption">kW</span>
                            </div>
                        </span>
                    </v-flex>
                    <v-flex text-center>
                        <span class="font-weight-bold">
                            STORAGE
                            <div class="subheading">
                                {{ totalsStorage | num }}
                                <span class="caption">kW</span>
                            </div>
                        </span>
                    </v-flex>
                    <v-flex text-center>
                        <span class="font-weight-bold">
                            DEMAND MGMT
                            <div class="subheading">
                                {{ totalsDemandMgmt | num }}
                                <span class="caption">kW</span>
                            </div>
                        </span>
                    </v-flex>
                    <v-flex text-center>
                        <span class="font-weight-bold">
                            EE
                            <div class="subheading">
                                {{ totalsEE | num }} <span class="caption">kW</span>
                            </div>
                        </span>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>

        <!-- external  ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
        <v-card outlined flat>
            <v-card-text>
                <!-- summary -->
                <v-card flat>
                    <v-card-text>
                        <v-layout row>
                            <v-flex text-left>
                                <h3 class="body-2 text-uppercase font-weight-medium pl-2 mt-3">
                                    External Supply
                                </h3>
                            </v-flex>
                            <div class="flex-grow-1"></div>
                            
                            <v-flex text-right>
                                <div class="display-1 text-right grey--text text--darken-3 compress">
                                    {{ totalsExternal | num }}
                                    <span class="caption">kW</span>
                                </div>
                            </v-flex>
                        </v-layout>
                        <v-divider px-2></v-divider>

                        <!-- assets -->
                        <v-layout row>
                            <table width="100%" border="0">
                                <tbody style="border:0;">
                                    <tr v-for="(item,e) in externalSupply" 
                                        :key="e"
                                        class="text-left subheading"
                                        style="border:0;"
                                        >
                                        <td>
                                            <v-img :src="genImg(item.key)" class="pr-1" width="30px"></v-img>
                                        </td>
                                        <td>{{ item.name }} <span class="caption">({{ item.title }})</span></td>
                                        <td class="text-right"><strong>{{ item.value }}</strong> {{ item.unit }}</td>
                                        <td class="text-right">
                                            <v-icon
                                                @click="onRemove(item.component_id)"
                                                color="red darken-2"
                                                >
                                                delete_forever
                                            </v-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                
                        </v-layout>
                    </v-card-text>
                </v-card>

                <!-- totals -->
                <v-layout row class="indigo lighten-5">
                    <v-flex text-center>
                        <span class="font-weight-bold">
                            PEAK DEMAND
                            <div class="subheading">
                                {{ externalSupplyCalcs.peakDemandKw | num }}
                                <span class="caption">kWh</span>
                            </div>
                        </span>
                    </v-flex>
                    <v-flex text-center>
                        <span class="font-weight-bold">
                            ANNUAL USAGE
                            <div class="subheading">
                                {{ externalSupplyCalcs.annualUsageKw | num }}
                                <span class="caption">kWh</span>
                            </div>
                        </span>
                    </v-flex>
                    <v-flex text-center>
                        <span class="font-weight-bold">
                            LOAD FACTOR
                            <div class="subheading">
                                {{ parseFloat( externalSupplyCalcs.loadFactor ).toFixed(2) }}%
                            </div>
                        </span>
                    </v-flex>
                    <v-flex text-center>
                        <span class="font-weight-bold">
                            AVG COST/kWh
                            <div class="subheading">
                                {{ externalSupplyCalcs.costKwh }}
                            </div>
                        </span>
                    </v-flex>
                </v-layout>

            </v-card-text>
        </v-card>
      </v-col>

      <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
      <!-- right ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
      <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
      <v-col md="5">
        <v-card outlined flat class="mb-4 pb-4">
            <v-toolbar dense flat>
                <v-toolbar-title>
                    <h3 class="title font-weight-light pl-1">
                      <v-avatar color="secondary darken-1" size="24">
                          <span class="white--text body-1 font-weight-bold">3</span>
                      </v-avatar>
                      {{ resultsPanelTitle }}
                    </h3>
                </v-toolbar-title>

                <div class="flex-grow-1"></div>

                <!-- simulate financials / avoided  -->
                <v-tooltip top color="light-green">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            @click="onRunSimulation"
                            fab
                            small
                            color="light-green"
                            dark
                            elevation-4
                            class="up50"
                            >
                            <v-icon medium color="white">attach_money</v-icon>
                        </v-btn>
                    </template>
                    <span class="white--text body-2">
                        Run financials/avoided simulation</span>
                </v-tooltip>
                <!-- simulate guidance -->
                <v-tooltip top color="blue">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            @click="onRunGuidance"
                            fab
                            small
                            color="blue"
                            dark
                            elevation-4
                            class="up50"
                            >
                            <v-icon medium color="white">directions</v-icon>
                        </v-btn>
                    </template>
                    <span class="white--text body-2">Simulate Guidance</span>
                </v-tooltip>
                <!-- reset data -->
                <v-tooltip top color="orange darken-3">
                    <template v-slot:activator="{ on }">
                        <v-btn
                            v-on="on"
                            @click="onClear"
                            fab
                            small
                            color="orange darken-3"
                            dark
                            elevation-4
                            class="up50"
                            >
                            <v-icon medium>clear</v-icon>
                        </v-btn>
                    </template>
                    <span class="white--text body-2">Reset data</span>
                </v-tooltip>
            </v-toolbar>            

            <!-- no results  ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <v-card-text v-if="!resultsAvailable">
                There are no simulation results. <br />
                Configure your microgrid and run a simulation.
            </v-card-text>

            <!-- simulation results  ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <v-card-text v-if="resultsAvailable && simulationResultsAvailable">
                <v-layout row>
                    <v-flex xs8 text-left>
                        <h3 class="title font-weight-bold">
                            Annual Dollars
                            <v-tooltip top color="light-green">
                              <template v-slot:activator="{ on }">
                                <v-icon v-on="on" color="light-green">info</v-icon>
                              </template>                
                              <span class="text-left font-weight-bold body-2 white--text">
                              Annual net revenue and savings from all grid-facing<br />value
                              streams (less variable costs like fuel)
                              </span>
                            </v-tooltip>
                        </h3>
                    </v-flex>
                    <v-flex xs4 text-right>
                        <v-tooltip top color="light-green">
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              @click="toggleDashboard"
                              icon
                              outlined
                              small
                              color="light-green"
                            >
                              <v-icon v-on="on" color="light-green">more_horiz</v-icon>
                            </v-btn>
                          </template>                
                          <span class="text-left font-weight-bold body-2 white--text"> View details</span>
                         </v-tooltip>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs12>
                        <highcharts
                            id="dollarGauge"
                            ref="highcharts"
                            v-show="showGauges"
                            v-model="dollarsGaugeOptions"
                            :options="dollarsGaugeOptions"
                            style="height: 220px;"
                            ></highcharts>
                    </v-flex>
                </v-layout>
                <v-divider class="mt-3 mb-3"></v-divider>
                <v-layout row>
                    <v-flex xs8 text-left>
                        <h3 class="title font-weight-bold">
                            Annual Avoided Carbon
                            <v-tooltip top color="#ffa500">
                              <template v-slot:activator="{ on }">
                                <v-icon slot="activator" v-on="on" color="#ffa500">info</v-icon>
                              </template>                
                              <span class="text-left font-weight-bold body-2 white--text">
                                Total net carbon emissions avoided by generating<br />power
                                onsite instead of taking power from the grid.
                              </span>
                            </v-tooltip>
                        </h3>
                    </v-flex>
                    <v-flex xs4 text-right>
                        <v-tooltip top color="#ffa500">
                          <template v-slot:activator="{ on }">
                            <v-btn
                              v-on="on"
                              @click="toggleDashboard"
                              icon
                              outlined
                              small
                              color="#ffa500"
                            >
                              <v-icon v-on="on" color="#ffa500">more_horiz</v-icon>
                            </v-btn>
                          </template>                
                          <span class="text-left font-weight-bold body-2 white--text"> View details</span>
                         </v-tooltip>
                    </v-flex>
                </v-layout>
                <v-layout row>
                    <v-flex xs12 text-center>
                        <highcharts
                            id="avoidedGauge"
                            ref="highcharts"
                            v-show="showGauges"
                            v-model="avoidedGaugeOptions"
                            :options="avoidedGaugeOptions"
                            style="height: 220px;"
                            ></highcharts>
                    </v-flex>
                </v-layout>
            </v-card-text>
            <!-- guidance results  ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
            <v-card-text v-if="resultsAvailable && guidanceResultsAvailable">
                <v-card class="mt-3 mx-auto elevation-0">
                    <v-sheet
                        class="v-sheet--offset mx-auto"
                        color="blue"
                        elevation="20"
                        max-width="calc(100% - 32px)"
                        >
                        <v-sparkline
                            :labels="guidanceLabels"
                            :value="guidanceValues"
                            v-model="guidanceValues"
                            color="white"
                            line-width="1"
                            padding="16"
                            ></v-sparkline>
                    </v-sheet>
                    <v-card-text class="pt-0 text-center">
                        <div class="title font-weight-light mt-2 mb-3">Today's Guidance</div>
                        <v-divider></v-divider>
                        <v-layout row mt-2>
                            <v-flex>
                                <div class="subheading font-weight-light">
                                    #Run Events: {{ guidanceTotalRuns }}
                                </div>
                            </v-flex>
                            <v-flex>
                                <div class="subheading font-weight-light">
                                    Annualized Value: ${{ guidanceTotalValue | num }}
                                </div>
                            </v-flex>
                            <v-flex text-right>
                              <v-tooltip top color="blue">
                                <template v-slot:activator="{ on }">
                                  <v-btn
                                    v-on="on"
                                    @click="toggleDashboard"
                                    icon
                                    outlined
                                    small
                                    color="blue"
                                  >
                                    <v-icon v-on="on" color="blue">more_horiz</v-icon>
                                  </v-btn>
                                </template>                
                                <span class="text-left font-weight-bold body-2 white--text"> View details</span>
                              </v-tooltip>
                            </v-flex>
                        </v-layout>
                        <v-divider pb-4></v-divider>
                    </v-card-text>
                </v-card>
            </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- simulation dashboard ~**~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <DollarsDashboard
        v-show="dashboardOpen"
        v-if="resultsAvailable && simulationResultsAvailable"
        :internalSupply="internalSupply"
        :externalSupply="externalSupplyCalcs"
        :dollarsResults="dollarsResults"
        :avoidedResults="avoidedResults"
        ></DollarsDashboard>
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- guidance dashboard ~**~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <GuidanceDashboard
        v-show="dashboardOpen"
        v-if="resultsAvailable && guidanceResultsAvailable"
        :exId="guidanceMockExampleId"
        :microgrid="guidanceMicrogrid"
        v-model="guidanceMicrogrid"
        ></GuidanceDashboard>
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- running dialog *~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <v-dialog v-model="runningDialog" persistent width="500">
        <v-card color="primary" dark>
            <v-card-text class="headline white--text">
                <img src="/img/sustaine-32x32.png" />
                Running Your Custom Simulation
                <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                    ></v-progress-linear>
            </v-card-text>
        </v-card>
    </v-dialog>
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- configuration  *~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
    <v-bottom-sheet :value="bottomSheetOpen" persistent inset>
        <v-layout  v-if="selectedComponent" row>
            <v-flex xs12>
                <v-card class="text-left">
                    <v-card-title class="blue-grey lighten-5">
                        <v-layout row>
                            <v-flex xs1 text-right>
                                <v-img
                                    :src="genImg(selectedComponent.key)"
                                    width="30"
                                    ></v-img>
                            </v-flex>
                            <v-flex xs11 text-left>
                                <h3 class="title compress mt-1">
                                    Configure {{ selectedComponent.title }} Parameters
                                </h3>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- wind  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <v-card-text v-if="selectedComponent.key == 'wind'">
                        <!-- title -->
                        <v-form ref="form">
                            DATA
                        </v-form>
                    </v-card-text>
                    <!-- //// wind -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- offset  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <v-card-text v-if="selectedComponent.key == 'offsets'">
                        <!-- title -->
                        <v-form ref="form">
                            <v-layout wrap row>
                                <v-flex text-left>
                                    <v-text-field
                                        class="pr-2"
                                        label="Component Name"
                                        :value="selectedComponent.name"
                                        v-model.trim="selectedComponent.name"
                                        ></v-text-field>
                                </v-flex>
                                <v-flex text-left>
                                    <v-text-field
                                        class="pr-2"
                                        label="Total MWh Offsets"
                                        value="100000"
                                        ></v-text-field>
                                </v-flex>
                                <v-flex text-left>
                                    <v-text-field
                                        label="Price per MWh"
                                        value="2.5516"
                                        prepend-inner-icon="attach_money"
                                        ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <!-- //// wind -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- efficiency (ee) ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <v-card-text v-if="selectedComponent.key == 'efficiency'">
                        <!-- title -->
                        <v-form ref="form">
                            <v-layout wrap row>
                                <v-flex text-left>
                                    <v-text-field
                                        class="pr-2"
                                        label="Component Name"
                                        :value="selectedComponent.name"
                                        v-model.trim="selectedComponent.name"
                                        ></v-text-field>
                                </v-flex>
                                <v-flex text-left>
                                    <v-text-field
                                        class="pr-2"
                                        label="Annual kWh Reduction"
                                        value="327000"
                                        ></v-text-field>
                                </v-flex>
                                <v-flex text-left>
                                    <v-text-field
                                        label="Peak kW Reduction"
                                        :value="selectedComponent.value"
                                        v-model.trim="maxOutputkW"
                                        ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <!-- //// wind -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- external supply  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <v-card-text v-else-if="selectedComponent.key == 'external'">
                        <v-form ref="form">
                            <v-layout wrap row>
                                <v-flex text-left>
                                    <v-text-field
                                        label="Component Name"
                                        :value="selectedComponent.name"
                                        v-model.trim="selectedComponent.name"
                                        ></v-text-field>
                                </v-flex>
                                <v-flex xs1></v-flex>
                                <v-flex text-left>
                                    <v-text-field
                                        v-model="selectedComponent.peakDemandKw"
                                        label="Peak Demand"
                                        @input="calculateComponentLoadFactor()"
                                        ></v-text-field>
                                </v-flex>
                                <v-flex xs1></v-flex>
                                <v-flex text-left>
                                    <v-text-field
                                        v-model="selectedComponent.annualUsageKw"
                                        label="Annual Usage"
                                        @input="calculateComponentLoadFactor()"
                                        ></v-text-field>
                                </v-flex>
                                <v-flex xs1></v-flex>
                                <v-flex text-left>
                                    <v-text-field
                                        v-model="selectedComponent.loadFactor"
                                        label="Load Factor"
                                        readonly
                                        ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <!-- fixed checkbox -->
                            <v-layout wrap row py-1>
                                <v-flex xs2>
                                    <v-checkbox
                                        v-model="checkboxOn"
                                        label="Fixed"
                                        checked
                                        ></v-checkbox>
                                </v-flex>
                                <v-flex xs2 text-left>
                                    <v-text-field
                                        v-model="selectedComponent.costKwh"
                                        label="Cost $/kWh"
                                        ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <!-- time of use -->
                            <v-layout wrap row pb-4>
                                <v-flex xs2>
                                    <v-checkbox
                                        v-model="checkboxOff"
                                        label="Time of Use"
                                        disabled
                                        ></v-checkbox>
                                </v-flex>
                                <v-flex xs7 text-left>
                                    <v-text-field label="On Peak $/kWh" disabled></v-text-field>
                                    <table width="100%" style="color: #999999" class="pb-2">
                                        <thead>
                                            <tr align="center">
                                                <th></th>
                                                <th>MON</th>
                                                <th>TUE</th>
                                                <th>WED</th>
                                                <th>THU</th>
                                                <th>FRI</th>
                                                <th>SAT</th>
                                                <th>SUN</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr style="border-bottom: 1px solid #333;">
                                                <td>Start</td>
                                                <td>07:30</td>
                                                <td>07:30</td>
                                                <td>07:30</td>
                                                <td>07:30</td>
                                                <td>07:30</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                            <tr style="border-bottom: 1px solid #333;">
                                                <td>End:</td>
                                                <td>20:00</td>
                                                <td>20:00</td>
                                                <td>20:00</td>
                                                <td>20:00</td>
                                                <td>20:00</td>
                                                <td></td>
                                                <td></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    <v-text-field
                                        label="Off Peak $/kWh"
                                        disabled
                                        ></v-text-field>
                                </v-flex>
                            </v-layout>
                            <!-- variable -->
                            <v-layout wrap row>
                                <v-flex xs2>
                                    <v-checkbox
                                        v-model="checkboxOff"
                                        label="Variable"
                                        disabled
                                        ></v-checkbox>
                                </v-flex>
                                <v-flex xs2 text-left>
                                    <v-text-field label="Type" disabled></v-text-field>
                                </v-flex>
                                <v-flex xs2 text-left>
                                    <v-text-field label="ISO" disabled></v-text-field>
                                </v-flex>
                                <v-flex xs2 text-left>
                                    <v-text-field label="Node ID" disabled></v-text-field>
                                </v-flex>
                                <v-flex xs2 text-left>
                                    <v-text-field label="Node Name" disabled></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <!-- //// external -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- generation  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <v-card-text v-else-if="selectedComponent.key == 'generation'">
                        <v-form ref="form" text-left>
                            <v-layout row>
                                <v-flex xs12 md5>
                                    <table>
                                        <tbody>
                                            <tr
                                                v-for="(config,
                                                index) in selectedComponent.configuration"
                                                :key="index"
                                                >
                                                <td>{{ config.name }}</td>
                                                <td class="text-right">
                                                    {{ config | values }}
                                                </td>
                                                <td class="text-left">
                                                    {{ config.unit | units }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <h3 class="subheading compress">
                                        Type:
                                    </h3>
                                    <v-radio-group
                                        v-model="generationRadios"
                                        :mandatory="false"
                                        >
                                        <v-radio
                                            label="CoGeneration"
                                            value="CoGeneration"
                                            ></v-radio>
                                        <v-radio
                                            disabled
                                            label="Thermal"
                                            value="Thermal"
                                            ></v-radio>
                                        <v-radio disabled label="Peaker" value="Peaker"></v-radio>
                                        <v-radio disabled value="Other">
                                            <div slot="label">
                                                <v-text-field disabled value="Other"></v-text-field>
                                            </div>
                                        </v-radio>
                                    </v-radio-group>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <h3 class="subheading compress">
                                        Component Name:
                                    </h3>
                                    <v-text-field
                                        :value="selectedComponent.name"
                                        v-model.trim="selectedComponent.name"
                                        ></v-text-field>
                                    <h3 class="subheading compress pt-3">
                                        Max Output (kW):
                                    </h3>
                                    <v-text-field
                                        :value="selectedComponent.value"
                                        v-model.trim="maxOutputkW"
                                        ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <!-- //// generation -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- storage  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <v-card-text
                        v-else-if="
                        selectedComponent.key == 'storage_battery' ||
                        selectedComponent.key == 'storage_thermal'
                        "
                        >
                        <v-form ref="form" text-left>
                            <v-layout row>
                                <v-flex xs12 md8>
                                    <table>
                                        <tbody>
                                            <tr
                                                v-for="(config,
                                                index) in selectedComponent.configuration"
                                                :key="index"
                                                >
                                                <td>{{ config.name }}</td>
                                                <td class="text-right">
                                                    {{ config | values }}
                                                </td>
                                                <td class="text-left">
                                                    {{ config.unit | units }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </v-flex>
                                <v-flex xs12 md4>
                                    <h3 class="subheading compress mt-3">
                                        Component Name:
                                    </h3>
                                    <v-text-field
                                        :value="selectedComponent.name"
                                        v-model.trim="selectedComponent.name"
                                        ></v-text-field>
                                    <h3 class="subheading compress">
                                        Max Output (kW):
                                    </h3>
                                    <v-text-field
                                        :value="selectedComponent.value"
                                        v-model.trim="maxOutputkW"
                                        ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <!-- //// storage -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- solar  ~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <v-card-text v-else-if="selectedComponent.key == 'solar'">
                        <v-form ref="form" text-left>
                            <v-layout row>
                                <v-flex xs12 md5>
                                    <table>
                                        <tbody>
                                            <tr
                                                v-for="(config,
                                                index) in selectedComponent.configuration"
                                                :key="index"
                                                >
                                                <td>{{ config.name }}</td>
                                                <td class="text-right">
                                                    {{ config | values }}
                                                </td>
                                                <td class="text-left">
                                                    {{ config.unit | units }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <h3 class="subheading compress">
                                        Component Name:
                                    </h3>
                                    <v-text-field
                                        :value="selectedComponent.name"
                                        v-model.trim="selectedComponent.name"
                                        ></v-text-field>
                                    <h3 class="subheading compress mt-3">
                                        Max Output (kW):
                                    </h3>
                                    <v-text-field
                                        :value="selectedComponent.value"
                                        v-model.trim="maxOutputkW"
                                        ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <!-- //// solar -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- demand mgmt ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <!-- ~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~*~* -->
                    <v-card-text v-else-if="selectedComponent.key == 'demand_mgmt'">
                        <v-form ref="form" text-left>
                            <v-layout row>
                                <v-flex xs12 md5>
                                    <table>
                                        <tbody>
                                            <tr
                                                v-for="(config,
                                                index) in selectedComponent.configuration"
                                                :key="index"
                                                >
                                                <td>{{ config.name }}</td>
                                                <td class="text-right">
                                                    {{ config | values }}
                                                </td>
                                                <td class="text-left">
                                                    {{ config.unit | units }}
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </v-flex>
                                <v-flex xs12 md3>
                                    <h3 class="subheading compress">
                                        Type:
                                    </h3>
                                    <v-radio-group
                                        v-model="curtailmentRadios"
                                        :mandatory="false"
                                        >
                                        <v-radio label="Automated" value="Automated"></v-radio>
                                        <v-radio disabled label="Manual" value="Manual"></v-radio>
                                    </v-radio-group>
                                </v-flex>
                                <v-flex xs12 md2>
                                    <h3 class="subheading compress">
                                        Component Name:
                                    </h3>
                                    <v-text-field
                                        :value="selectedComponent.name"
                                        v-model.trim="selectedComponent.name"
                                        ></v-text-field>
                                    <h3 class="subheading compress">
                                        Duration (minutes):
                                    </h3>
                                    <v-text-field value="150"></v-text-field>
                                    <h3 class="subheading compress">
                                        Maximum Reduction (kW):
                                    </h3>
                                    <v-text-field
                                        :value="selectedComponent.value"
                                        v-model.trim="maxOutputkW"
                                        ></v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-form>
                    </v-card-text>
                    <!-- //// demand_management -->
                    <!-- actions (global) -->
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn @click="onCancel" small dark color="grey">CANCEL</v-btn>
                        <v-btn @click="onSave" small dark color="primary">SAVE</v-btn>
                    </v-card-actions>
                    <v-spacer></v-spacer>
                </v-card>
            </v-flex>
        </v-layout>
    </v-bottom-sheet>
  </v-container>
</template>

<script>
import DollarsDashboard from './DollarsDashboard'
import GuidanceDashboard from './GuidanceDashboard'
import simualationEngineRawData from '@/json/simulate_engine.json'
export default {
  name: 'SimulateEngine',
  components: {
    DollarsDashboard,
    GuidanceDashboard
  },
  computed: {
    getJsonRaw() {
      // return MockDataService.getSimulationData(4)
      return simualationEngineRawData
    },
    internalSupply() {
      let ret = []
      for (var x = 0; x < this.activeComponents.length; x++) {
        if (this.isInternal(this.activeComponents[x])) {
          ret.push(this.activeComponents[x])
        }
      }
      return ret
    },
    externalSupply() {
      let ret = []
      for (var x = 0; x < this.activeComponents.length; x++) {
        if (this.isExternal(this.activeComponents[x])) {
          ret.push(this.activeComponents[x])
        }
      }
      return ret
    }
  },
  filters: {
    units(value) {
      if (value === 'currency') return
      return value
    },
    num(value) {
      var formatter = new Intl.NumberFormat('en-US', {
        style: 'decimal',
        currency: 'USD',
        minimumFractionDigits: 0
      })
      return formatter.format(value)
    },
    values(value) {
      if (value.unit == 'currency') {
        return '$' + value.value
      }
      return value.value
    }
  },
  watch: {
    activeComponents() {
      this.genTotals()
    },
    runningDialog(val) {
      if (!val) return
      this.resultsAvailable = false
      setTimeout(
        () => ((this.runningDialog = false), (this.resultsAvailable = true)),
        this.delayMSecs
      )
    }
  },
  data() {
    return {
      guidanceLabels: [
        '12am',
        '4am',
        '8am',
        '10am',
        '12pm',
        '2pm',
        '4pm',
        '6pm',
        '8pm',
        '12am'
      ],
      guidanceValues: [1, 1, 1, 1, 1, 200, 200, 1, 1, 1],
      guidanceTotalValue: false,
      guidanceTotalRuns: false,
      guidanceMockExampleId: false,
      guidanceMicrogrid: [],

      components: [],
      activeComponents: [],

      // THESE #'s ARE IN JSON AS WELL, IF CHANGE, KEEP IN SYNC
      externalSupplyCalcs: {
        type: 'fixed',
        peakDemandKw: 0,
        loadFactor: 0,
        annualUsageKw: 0,
        costKwh: 0
      },

      goalDollars: 600000,
      goalCarbon: 8000,
      delayMSecs: 5000, // animation time on gauges matches dialog display time
      generationRadios: 'CoGeneration',
      curtailmentRadios: 'Automated',
      showGauges: false,
      dashboardOpen: false,
      runningDialog: false,
      deleteDialog: false,
      bottomSheetOpen: false,
      selectedComponent: false,
      selectedComponentIdx: false,
      valid: false,
      maxOutputkW: 0,
      checkboxOn: true,
      checkboxOff: false,
      totalsInternal: 0.0,
      totalsExternal: 0.0,
      peakDemandTotal: 0.0,
      annualUsageTotal: 0.0,
      costTotal: 0.0,
      avgCostTotal: 0.0,
      totalsSolar: 0.0,
      totalsWind: 0.0,
      totalsEE: 0.0,
      totalsStorage: 0.0,
      totalsGeneration: 0.0,
      totalsDemandMgmt: 0.0,

      dollarsGaugeOptions: false,
      avoidedGaugeOptions: false,

      dollarsResults: false,
      avoidedResults: false,
      resultsAvailable: false,
      simulationResultsAvailable: false,
      guidanceResultsAvailable: false,
      resultsPanelTitle: 'Run a Simulation'
    }
  },

  mounted() {
    this.fetch()
  },
  methods: {
    fetch() {
      let json = this.getJsonRaw
      for (var z = 0; z < json.masterComponents.length; z++) {
        let mc = json.masterComponents[z]
        this.components.push(mc)
      }
      for (var y = 0; y < json.components.length; y++) {
        let c = json.components[y]
        // console.log('json.component key/value  ' + c.key + ' ' + c.value)
        this.activeComponents.push(c)
      }
      this.rollingIdCounter = this.activeComponents.length + 1
    },
    toTitleCase(str) {
      str = str.replace('_', ' ')
      return str.replace(/\w\S*/g, function(txt) {
        return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase()
      })
    },
    genImg(key, suffix = false) {
      if (typeof key === 'undefined') return
      if (suffix) {
        return '/img/simulate/avatars/' + key + suffix + '.png'
      }
      return '/img/simulate/avatars/' + key + '.png'
    },
    genTotals() {
      // console.log('genTotals')
      this.totalsInternal = 0.0
      this.totalsSolar = 0.0
      this.totalsWind = 0.0
      this.totalsStorage = 0.0
      this.totalsGeneration = 0.0
      this.totalsDemandMgmt = 0.0
      this.totalsEE = 0.0

      let ilist = this.internalSupply
      for (var x = 0; x < ilist.length; x++) {
        let val = parseFloat(ilist[x].value)
        let key = ilist[x].key
        this.totalsInternal += val
        if (key == 'solar') {
          this.totalsSolar += val
        } else if (key == 'efficiency') {
          this.totalsEE += val
        } else if (key == 'wind') {
          this.totalsWind += val
        } else if (key.indexOf('storage') > -1) {
          this.totalsStorage += val
        } else if (key == 'generation') {
          this.totalsGeneration += val
        } else if (key == 'demand_mgmt') {
          this.totalsDemandMgmt += val
        }
      }

      this.totalsExternal = 0.0
      this.peakDemandTotal = 0.0
      this.annualUsageTotal = 0.0
      this.costTotal = 0.0
      this.avgCostTotal = 0.0

      let totalPeakDemandCost = 0.0
      for (var y = 0; y < this.externalSupply.length; y++) {
        this.peakDemandTotal += parseFloat(this.externalSupply[y].peakDemandKw)
        this.annualUsageTotal += parseFloat(
          this.externalSupply[y].annualUsageKw
        )
        this.costTotal += parseFloat(this.externalSupply[y].costKwh)
        totalPeakDemandCost = parseFloat(
          this.externalSupply[y].peakDemandKw * this.externalSupply[y].costKwh
        )
      }
      this.externalSupplyCalcs.peakDemandKw = 0.0
      this.externalSupplyCalcs.annualUsageKw = 0.0
      this.externalSupplyCalcs.loadFactor = 0.0
      this.externalSupplyCalcs.costKwh = 0.0

      this.externalSupplyCalcs.peakDemandKw = this.peakDemandTotal
      this.externalSupplyCalcs.annualUsageKw = this.annualUsageTotal
      this.avgCostTotal = parseFloat(
        totalPeakDemandCost / this.peakDemandTotal
      ).toFixed(6)
      this.externalSupplyCalcs.costKwh = this.avgCostTotal

      this.totalsExternal = this.peakDemandTotal // + this.annualUsageTotal + this.costTotal

      let LF = parseFloat(
        this.annualUsageTotal / (this.peakDemandTotal * 8760.0)
      )
      this.externalSupplyCalcs.loadFactor = parseFloat((LF * 100.0).toFixed(2))
    },
    calculateComponentLoadFactor() {
      let res = parseFloat(
        this.selectedComponent.annualUsageKw /
          (this.selectedComponent.peakDemandKw * 8760.0)
      )
      this.selectedComponent.loadFactor = parseFloat((res * 100.0).toFixed(2))
    },

    isExternal(component) {
      if (component.key == 'load') {
        return true
      }
      if (component.key == 'external') {
        return true
      }
      return false
    },
    isInternal(component) {
      let isExt = this.isExternal(component)
      return !isExt
    },

    onAdd(key) {
      console.log("on add")
      if (key === 'wind') return
      if (key === 'offsets') return
      
      this.selectedComponent = Object.assign({}, this.getComponentByKey(key))
      // name change
      let keyCount = this.getComponentCountByKey(key)
      this.selectedComponent.name = this.selectedComponent.title + ' #' + (keyCount + 1)
      if (key === 'efficiency' ) {
        this.selectedComponent.name = 'EE Project #' + (keyCount + 1)        
      }
      if (this.selectedComponent.key === 'demand_mgmt') {
        this.selectedComponent.name = 'Demand Mgmt #' + (keyCount + 1)
      }
      // save
      this.activeComponents.push(this.selectedComponent)
      // edit
      this.maxOutputkW = this.selectedComponent.value
      this.bottomSheetOpen = true
    },
    onEdit(id) {
      this.selectedComponent = this.getActiveComponentById(id)
      // console.log("selectedComponent", this.selectedComponent)
      this.maxOutputkW = this.selectedComponent.value
      this.bottomSheetOpen = true
    },
    onCancel() {
      // back out add new when dialog cancel clicked.
      // if not new, leave in and just shut down editing
      if (this.selectedComponent.component_id === 0) {
        this.onRemove(this.selectedComponent.component_id) // 0, duh
      }
      // reset environment
      this.selectedComponent = false
      this.maxOutputkW = 0
      this.bottomSheetOpen = false
    },
    onRemove(id) {
      let idx = this.getComponentIndexById(id)
      this.activeComponents.splice(idx, 1)
      return true
    },
    onSave() {
      // console.log("maxOutputkW", this.maxOutputkW)
      // console.log("selectedComponent", this.selectedComponent)

      // bottomSheetOpen ... or new ... ?
      if (this.selectedComponent.component_id === 0) {
        // new
        this.rollingIdCounter++
        this.selectedComponent.component_id = this.rollingIdCounter
        this.selectedComponent.value = this.maxOutputkW
        if (this.isExternal(this.selectedComponent)) {
          this.selectedComponent.value = this.selectedComponent.peakDemandKw
        }
      } else {
        // edit existing
        let comp = this.getActiveComponentById(
          this.selectedComponent.component_id
        )
        comp.value = this.maxOutputkW
        if (this.isExternal(this.selectedComponent)) {
          comp.value = this.selectedComponent.peakDemandKw
        }
      }

      this.genTotals()

      // reset bottomSheetOpen fields
      this.selectedComponent = false
      this.bottomSheetOpen = false

      // scream 'oh yah...'
      this.$toast.success("Configuration saved.")
    },
    onRunSimulation() {
      this.resultsAvailable = false
      this.guidanceResultsAvailable = false
      this.simulationResultsAvailable = false
      this.runningDialog = true
      this.runCalcs()
      this.genGauges()
      this.resultsAvailable = true
      this.simulationResultsAvailable = true
      this.resultsPanelTitle = 'Your Simulation Results'
    },
    onRunGuidance() {
      this.resultsAvailable = false
      this.guidanceResultsAvailable = false
      this.simulationResultsAvailable = false
      this.runningDialog = true
      this.guidanceMockExampleId = false

      // two scenarios
      // import guidance8 from '@/json/guidance/gen_less_demand.json'
      // import guidance9 from '@/json/guidance/gen_more_demand.json'

      if (this.totalsInternal <= this.totalsExternal) {
        // generated less than demand
        // 5CP: yes  |  NCP: yes |  DA: no  |  RT: no
        this.guidanceValues = [1, 1, 1, 1, 1, 200, 200, 1, 1, 1]
        this.guidanceTotalRuns = 1
        this.guidanceMockExampleId = 8
      } else {
        // generated more than demand
        // 5CP: yes  |  NCP: yes |  DA: yes  |  RT: yes
        this.guidanceValues = [1, 1, 100, 100, 1, 200, 200, 1, 1, 1]
        this.guidanceTotalRuns = 2
        this.guidanceMockExampleId = 9
      }

      // populate microgrid data
      this.guidanceMicrogrid = []
      this.guidanceMicrogrid = {
        peakDemand: this.externalSupplyCalcs.peakDemandKw,
        loadFactor: this.externalSupplyCalcs.loadFactor,
        annualUsageKw: this.externalSupplyCalcs.annualUsageKw,
        costKwh: this.externalSupplyCalcs.costKwh,
        generation: this.totalsGeneration,
        solar: this.totalsSolar,
        demandMgmt: this.totalsDemandMgmt,
        storage: this.totalsStorage
      }

      this.resultsAvailable = true
      this.guidanceResultsAvailable = true
      this.resultsPanelTitle = 'Your Simulation Results'
    },
    getDefaultData() {
      return {
        guidanceLabels: [
          '12am',
          '4am',
          '8am',
          '10am',
          '12pm',
          '2pm',
          '4pm',
          '6pm',
          '8pm',
          '12am'
        ],
        guidanceValues: [1, 1, 1, 1, 1, 200, 200, 1, 1, 1],
        guidanceTotalValue: false,
        guidanceTotalRuns: false,
        guidanceMockExampleId: false,
        guidanceMicrogrid: [],

        components: [],
        activeComponents: [],

        // THESE #'s ARE IN JSON AS WELL, IF CHANGE, KEEP IN SYNC
        externalSupplyCalcs: {
          type: 'fixed',
          peakDemandKw: 4194,
          loadFactor: 60.32,
          annualUsageKw: 22164172,
          costKwh: 0.06157
        },

        goalDollars: 600000,
        goalCarbon: 8000,
        delayMSecs: 5000, // animation time on gauges matches dialog display time
        generationRadios: 'CoGeneration',
        curtailmentRadios: 'Automated',
        storageRadios: 'Battery',
        showGauges: false,
        dashboardOpen: false,
        runningDialog: false,
        deleteDialog: false,
        bottomSheetOpen: false,
        selectedComponent: false,
        selectedComponentIdx: false,
        valid: false,
        maxOutputkW: 0,
        checkboxOn: true,
        checkboxOff: false,
        totalsInternal: 0.0,
        totalsExternal: 0.0,
        totalsSolar: 0.0,
        totalsWind: 0.0,
        totalsStorage: 0.0,
        totalsGeneration: 0.0,
        totalsDemandMgmt: 0.0,

        dollarsGaugeOptions: false,
        avoidedGaugeOptions: false,

        dollarsResults: false,
        avoidedResults: false,
        resultsAvailable: false,
        simulationResultsAvailable: false,
        guidanceResultsAvailable: false,
        resultsPanelTitle: 'Run a Simulation'
      }
    },
    initialize() {
      // just refresh the page which runs initialization
      // this.$router.go()
      this.components = []
      this.activeComponents = []
      this.guidanceValues = []
      this.guidanceLabels = [
        '12am',
        '4am',
        '8am',
        '10am',
        '12pm',
        '2pm',
        '4pm',
        '6pm',
        '8pm',
        '12am'
      ]
      this.guidanceMicrogrid = []
      this.guidanceTotalValue = false
      this.guidanceTotalRuns = false
      this.guidanceMockExampleId = false
      this.externalSupplyCalcs = {
        type: 'fixed',
        peakDemandKw: 4194,
        loadFactor: 60.32,
        annualUsageKw: 22164172,
        costKwh: 0.06157
      }
      this.goalDollars = 600000
      this.goalCarbon = 8000
      this.delayMSecs = 5000
      this.generationRadios = 'CoGeneration'
      this.curtailmentRadios = 'Automated'
      this.storageRadios = 'Battery'
      this.showGauges = false
      this.dashboardOpen = false
      this.runningDialog = false
      this.deleteDialog = false
      this.bottomSheetOpen = false
      this.selectedComponent = false
      this.selectedComponentIdx = false
      this.valid = false
      this.maxOutputkW = 0
      this.checkboxOn = true
      this.checkboxOff = false
      this.totalsInternal = 0.0
      this.totalsExternal = 0.0
      this.totalsSolar = 0.0
      this.totalsWind = 0.0
      this.totalsStorage = 0.0
      this.totalsGeneration = 0.0
      this.totalsDemandMgmt = 0.0
      this.dollarsGaugeOptions = false
      this.avoidedGaugeOptions = false
      this.dollarsResults = false
      this.avoidedResults = false
      this.resultsAvailable = false
      this.simulationResultsAvailable = false
      this.guidanceResultsAvailable = false
      this.resultsPanelTitle = 'Run a Simulation'
    },
    onClear() {
      this.$router.go(this.$router.currentRoute)
      // console.log('active', this.activeComponents)
      // Object.assign(this.$data, this.getDefaultData())
      // console.log('active', this.activeComponents)
      // this.fetch()
      // console.log('active', this.activeComponents)
    },
    toggleDashboard() {
      this.dashboardOpen = !this.dashboardOpen
    },
    getComponentCountByKey(key) {
      let total = 0
      for (var x = 0; x < this.activeComponents.length; x++) {
        if (this.activeComponents[x].key === key) {
          total++
        }
      }
      return total
    },
    getActiveComponentByKey(key) {
      for (var x = 0; x < this.activeComponents.length; x++) {
        if (this.activeComponents[x].key === key) {
          return this.activeComponents[x]
        }
      }
      return null
    },
    getComponentByKey(key) {
      for (var x = 0; x < this.components.length; x++) {
        if (this.components[x].key === key) {
          return this.components[x]
        }
      }
      return null
    },
    getComponentIndexById(id) {
      for (var x = 0; x < this.activeComponents.length; x++) {
        if (this.activeComponents[x].component_id === id) {
          return x
        }
      }
      return null
    },

    getActiveComponentById(id) {
      for (var x = 0; x < this.activeComponents.length; x++) {
        if (this.activeComponents[x].component_id === id) {
          return this.activeComponents[x]
        }
      }
      return null
    },
    getComponentByTitle(title) {
      for (var x = 0; x < this.components.length; x++) {
        if (this.components[x].title === title) {
          return this.components[x]
        }
      }
      return null
    },
    runCalcs() {
      const AVOIDED_CARBON_PER_TON = 0.03647

      // console.log("generation total", this.totalsGeneration)
      const baseGenerationKw = 4940
      const baseGenerationDollars = 93160

      const baseSolarKw = 1992
      const baseSolarDollars = 52170

      const baseStorageKw = 100
      const baseStorageDollars = 11450

      // 'curtailment'
      const baseDemandMgmtKw = 1100
      const baseDemandMgmtDollars = 18632

      const basePeakDemandKw = 4194
      const basePeakDemandDollars = 93169

      const baseAnnualUsageKw = 34164172
      const baseAnnualUsageDollars = 48443

      const baseCostKwh = 0.06157
      const baseCostKwhDollars = 67075

      // generation
      let generationDiff = parseFloat(
        (this.totalsGeneration - baseGenerationKw) / baseGenerationKw
      )
      let generationAlloc = parseFloat(
        (generationDiff + 1.0) * baseGenerationDollars
      )
      // console.log("generationDiff", generationDiff)
      // console.log("generationAlloc", generationAlloc)
      // console.log("")

      // solar
      let solarDiff = parseFloat((this.totalsSolar - baseSolarKw) / baseSolarKw)
      let solarAlloc = parseFloat((solarDiff + 1.0) * baseSolarDollars)
      // console.log("solarDiff", solarDiff)
      // console.log("solarAlloc", solarAlloc)
      // console.log("")

      let storageDiff = parseFloat((this.totalsStorage - baseStorageKw) / baseStorageKw)
      let storageAlloc = parseFloat((storageDiff + 1.0) * baseStorageDollars)
        // console.log("storageDiff", storageDiff)
        // console.log("storageAlloc", storageAlloc)
        // console.log("")

      // curtailment
      let curtailmentDiff = parseFloat(
        (this.totalsDemandMgmt - baseDemandMgmtKw) / baseDemandMgmtKw
      )
      let curtailmentAlloc = parseFloat(
        (curtailmentDiff + 1.0) * baseDemandMgmtDollars
      )
      // console.log("curtailmentDiff", curtailmentDiff)
      // console.log("curtailmentAlloc", curtailmentAlloc)
      // console.log("")

      // peak demand
      let peakDemandDiff = parseFloat(
        (basePeakDemandKw - this.peakDemandTotal) / basePeakDemandKw
      )
      let peakDemandAlloc = parseFloat(
        (peakDemandDiff + 1.0) * basePeakDemandDollars
      )
      if (peakDemandDiff < 0) {
        peakDemandAlloc = 0.0
      }
      // console.log("peakDemandDiff", peakDemandDiff)
      // console.log("peakDemandAlloc", peakDemandAlloc)
      // console.log("")

      // annual usage
      let annualUsageDiff = parseFloat(
        (baseAnnualUsageKw - this.annualUsageTotal) / baseAnnualUsageKw
      )
      let annualUsageAlloc = parseFloat(
        (annualUsageDiff + 1.0) * baseAnnualUsageDollars
      )
      if (annualUsageDiff < 0) {
        annualUsageAlloc = 0.0
      }
      // console.log("annualUsageDiff", annualUsageDiff)
      // console.log("annualUsageAlloc", annualUsageAlloc)
      // console.log("")

      // cost kwh
      let costKwhDiff = parseFloat(
        (baseCostKwh - this.avgCostTotal) / baseCostKwh
      ) // this.costTotal) / baseCostKwh)
      let costKwhAlloc = (costKwhDiff + 1.0) * baseCostKwhDollars
      if (costKwhDiff < 0) {
        costKwhAlloc = 0.0
      }
      // console.log("costKwhDiff", costKwhDiff)
      // console.log("costKwhAlloc", costKwhAlloc)
      // console.log("")

      // totals for difference and $ allocations
      let totalDiff = parseFloat(generationDiff + solarDiff + storageDiff + curtailmentDiff + peakDemandDiff + annualUsageDiff + costKwhDiff)
      let totalAlloc  = parseFloat(generationAlloc + solarAlloc + storageAlloc + curtailmentAlloc + peakDemandAlloc + annualUsageAlloc + costKwhAlloc)
      // console.log("totalDiff", totalDiff)
      // console.log("totalAlloc", totalAlloc)
      // console.log("")

      // capacity sales
      let capacityDiff = parseFloat(
        (generationAlloc + costKwhAlloc) / totalAlloc
      )
      let capacityAllocDollars = parseFloat(capacityDiff * totalAlloc)
      // console.log("capacityDiff", capacityDiff)
      // console.log("capacityAllocDollars", capacityAllocDollars)
      // console.log("")

      // DR
      let drDiff = parseFloat(curtailmentAlloc / totalAlloc)
      let drAllocDollars = parseFloat(drDiff * totalAlloc)
      // console.log("drDiff", drDiff)
      // console.log("drAllocDollars", drAllocDollars)
      // console.log("")

      // energy sales
      let energyDiff = parseFloat((solarAlloc + annualUsageAlloc) / totalAlloc)
      let energyAllocDollars = energyDiff * totalAlloc
      // console.log("energyDiff", energyDiff)
      // console.log("energyAllocDollars", energyAllocDollars)
      // console.log("")

      // demand savings
      let demandSavingsDiff = parseFloat(peakDemandAlloc / totalAlloc)
      let demandSavingsAllocDollars = parseFloat(demandSavingsDiff * totalAlloc)
      // console.log("demandSavingsDiff", demandSavingsDiff)
      // console.log("demandSavingsAllocDollars", demandSavingsAllocDollars)
      // console.log("")

      let generationCarbonAlloc = generationAlloc * AVOIDED_CARBON_PER_TON
      let solarCarbonAlloc = solarAlloc * AVOIDED_CARBON_PER_TON
      let curtailmentCarbonAlloc = curtailmentAlloc * AVOIDED_CARBON_PER_TON
      let totalCarbon =
        generationCarbonAlloc + solarCarbonAlloc + curtailmentCarbonAlloc
      // console.log("generationCarbonAlloc", generationCarbonAlloc)
      // console.log("solarCarbonAlloc", solarCarbonAlloc)
      // console.log("curtailmentCarbonAlloc", curtailmentCarbonAlloc)
      // console.log("totalCarbon", totalCarbon)
      // console.log("")

      // create results obj for dashboard
      this.dollarsResults = false
      this.dollarsResults = {
        goal: this.goalDollars,
        total: totalAlloc.toFixed(2),
        achieved: parseFloat((totalAlloc / this.goalDollars) * 100.0).toFixed(
          2
        ),
        capacity: capacityAllocDollars,
        demandResponse: drAllocDollars,
        energySales: energyAllocDollars,
        demandSavings: demandSavingsAllocDollars
      }
      // console.log("dollarsResults", this.dollarsResults)
      // console.log("")

      this.avoidedResults = false
      this.avoidedResults = {
        goal: this.goalCarbon,
        total: totalCarbon.toFixed(2),
        achieved: parseFloat((totalCarbon / this.goalCarbon) * 100.0).toFixed(
          2
        ),
        solar: solarCarbonAlloc,
        generation: generationCarbonAlloc,
        curtailment: curtailmentCarbonAlloc
      }
      // console.log("avoidedResults", this.avoidedResults)
      // console.log("")
    },
    genGauges() {
      let delay = 1000 // = this.delayMSecs
      // console.log('genGauges() dollarsResults.total', this.dollarsResults.total)
      this.showGauges = false
      if (this.dollarsResults) {
        this.dollarsGaugeOptions = false
        this.dollarsGaugeOptions = {
          chart: {
            type: 'solidgauge',
            backgroundColor: '#fafafa'
          },
          title: null,
          tooltip: {
            enabled: false
          },
          exporting: {
            enabled: false
          },
          credits: {
            enabled: false
          },
          pane: {
            center: ['50%', '85%'],
            size: '140%',
            startAngle: -90,
            endAngle: 90,
            background: {
              backgroundColor: '#EEE',
              innerRadius: '60%',
              outerRadius: '100%',
              shape: 'arc'
            }
          },
          // the value axis
          yAxis: {
            stops: [
              [0.99, '#8BC34A'] // light-green
            ],
            plotLines: [
              {
                color: '#F44336', // Color value
                width: 2, // Width of the line
                value: this.goalDollars,
                zIndex: 10,
                dashStyle: 'dash',
                label: {
                  text:
                    'Goal ' +
                    parseInt(this.dollarsResults.goal).toLocaleString(),
                  verticalAlign: 'top',
                  y: -1
                }
              }
            ],
            min: 0,
            max: 1000000,
            title: {
              text: '',
              y: -70
            },
            lineWidth: 1,
            minorTickInterval: 0.1,
            tickAmount: 1,
            labels: {
              y: 16
            }
          },
          plotOptions: {
            solidgauge: {
              dataLabels: {
                y: 5,
                borderWidth: 0,
                useHTML: true
              },
              animation: {
                duration: delay
              }
            }
          },
          series: [
            {
              name: 'dollars',
              data: [parseInt(this.dollarsResults.total)],
              dataLabels: {
                zIndex: 5,
                format:
                  '<div style="text-align:center; top:-20px">' +
                  '<span style="font-size:2em;color:black;">$' +
                  parseInt(this.dollarsResults.total).toLocaleString() +
                  '</span><br/>' +
                  '<span style="font-size:12px;color:#55BF3B;"></span></div>'
              }
            }
          ]
        }
        this.showGauges = true
      }
      if (this.avoidedResults) {
        this.avoidedGaugeOptions = false
        this.avoidedGaugeOptions = {
          chart: {
            type: 'solidgauge',
            backgroundColor: '#fafafa'
          },
          title: null,
          tooltip: {
            enabled: false
          },
          exporting: {
            enabled: false
          },
          credits: {
            enabled: false
          },
          pane: {
            center: ['50%', '85%'],
            size: '140%',
            startAngle: -90,
            endAngle: 90,
            background: {
              backgroundColor: '#EEE',
              innerRadius: '60%',
              outerRadius: '100%',
              shape: 'arc'
            }
          },
          // the value axis
          yAxis: {
            stops: [
              [0.99, '#ffa500'] // orange // red #F44336
            ],
            plotLines: [
              {
                color: '#F44336', // Color value
                width: 2, // Width of the line
                value: this.avoidedResults.goal, // $ goal
                zIndex: 10,
                dashStyle: 'dash',
                label: {
                  text:
                    'Goal ' +
                    parseInt(this.avoidedResults.goal).toLocaleString(),
                  verticalAlign: 'top',
                  y: 10
                }
              }
            ],
            min: 0,
            max: 10000,
            title: {
              text: '',
              y: -70
            },
            lineWidth: 1,
            minorTickInterval: 0.1,
            tickAmount: 1,
            labels: {
              y: 16
            }
          },
          plotOptions: {
            solidgauge: {
              dataLabels: {
                y: 5,
                borderWidth: 0,
                useHTML: true
              },
              animation: {
                duration: delay
              }
            }
          },
          series: [
            {
              name: 'avoided',
              data: [parseInt(this.avoidedResults.total)],
              dataLabels: {
                format:
                  '<div style="text-align:center">' +
                  '<span style="font-size:25px;color:black;">' +
                  parseInt(this.avoidedResults.total).toLocaleString() +
                  ' ' +
                  '</span>' +
                  '<span style="font-size:11px;color:#777;">Tons</span></div>'
              }
            }
          ]
        }
        this.showGauges = true
      }
    }
  }
} // export
</script>
<style lang="scss" scoped>
.v-bottom-sheet {
  max-height: 800px;
  margin-bottom: 20px;
  border-top-right-radius: 4px;
  border-top-left-radius: 4px;
  -webkit-border-top-right-radius: 4px;
  -webkit-border-top-let-radius: 4px;
  -moz-border-radius-topright: 4px;
  -moz-border-radius-topleft: 4px;
}
table td {
  padding: 0.4rem;
  border-bottom: 1px solid #ddd;
}
</style>
